export const DEFAULT_DATE_FORMAT = 'dd-mm-yyyy';

export const DEFAULT_HOUR_FORMAT = '24';
